import React, { useState, useEffect, useCallback } from "react";
import { Container, Modal, Row, Col, Card, Button } from "react-bootstrap";
import ReadOnlyModal from "../../My Profile/ReadOnlyModal/ReadOnlyModal";
import sampleImage from "../../../../../public/assets/images/home/sample2.jpg";
import PropertyDetailTimer from "@/components/bid/PropertyDetailTimer";
import "./PropertyDetailsCard.css";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import {
  getBidDetailsById,
  getBidHistory,
  withdrawBidById,
  getAutoBidDetails,
  getCifDetails,
} from "@/api/bids";
import { baseApi } from "@/api/apiConfig";
import ConfirmOffer from "../ConfirmOffer/ConfirmOffer";
import imageOnTheWay from "../../../../../public/assets/images/imageOnTheWay.webp";
import CountdownTimer from "./CountdownTimer";
import { MdErrorOutline } from "react-icons/md";
import AuctionTimeLeft from "./AuctionTimeLeft";
import { ShimmerContentBlock } from "react-shimmer-effects";
import BidDetailsModal from "../BidDetailsModal/BidDetailsModal";
import BidHistoryModal from "../BidHistory/BidHistoryModal";
import Loader from "@/components/common/loader/Loader";
import AutoBidModal from "../AutoBidModal/AutoBidModal";
import PlaceBestBidModal from "@/components/pdp/BidCenter/PlaceBestBidModal";
import {
  getAvailableBackUpBidAmount,
  getPlaceBestBidDetails,
} from "@/api/bidDepositApiHold";

import {
  fetchPDPBidCenterDataSuccess,
  enableOwnItNow,
  fetchPDPInitialLoadSuccess,
  setSelectedBidAmount,
  fetchPDPLatestBidCenterData,
} from "@/redux/PDP/pdpSlice";
import {
  getBidCenterDetails,
  getPDPInitData,
  isUserAuthorised,
} from "@/api/PDP";

import { useDispatch } from "react-redux";
import { setListingId } from "@/bidFeature/propertyDetailSlice";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
import { getPropertyURL } from "@/utils/propertyNavigation";
import { markInternalNavigation } from "@/utils/attributionCapture";

//  import OfferDetailsModal from '../../MyOffers/OfferDetailModal/OfferDetailsModal';
const PropertyDetailsCard = ({
  bidsData,
  bidOfferDetailList,
  bidDetailsById,
  componentType,
  onOfferDetailsClick,
  loading,
  cifDeatils,
  resetPageNumber,
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const [showBidHistory, setShowBidHistory] = useState(false);
  const [showAutoBid, setShowAutoBid] = useState(false);
  const [autoBidData, setAutoBidData] = useState();
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const [openConfirmOffer, setOpenConfirmOffer] = useState(false);
  const [selectedListingId, setSelectedListingId] = useState("");
  const [bidDetails, setBidDetails] = useState();
  const [bidHistory, setBidHistory] = useState();
  const [selectedBidId, setSelectedBidId] = useState();
  const [selectedPropAdrs, setSelectedPropAdrs] = useState();
  const [showWithdrawConfirmation, setShowWithdrawConfirmation] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(bidsData);
  const [cifData, setCifData] = useState(cifDeatils);
  const [selectedBidAmountCIF, setSelectedBidAmountCIF] = useState();
  const [showBestBidModal, setShowBestBidModal] = useState(false);
  const [selectedPropCat, setSeletecPropCat] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [actionLoading, setActionLoading] = useState({});

  const setActionLoadingState = (key, isLoading) => {
    setActionLoading((prev) => ({ ...prev, [key]: isLoading }));
  };

  const isActionLoading = (key) => actionLoading[key] || false;

  const OFFER_ACTION_MAPPING = {
    BUYER_ACCEPT: "Buyer Accepted",
    BUYER_COUNTER: "Buyer Countered",
    BUYER_EXPIRED: "Buyer Offer Lapsed",
    BUYER_HNB: "Buyer Highest & Best",
    BUYER_REJECT: "Buyer Rejected",
    BUYER_WITHDRAWAL: "Buyer Withdrawn",
    CREATED: "Initial Offer",
    CREATE_EXPIRED: "Offer Expired",
    FALLOUT: "Fallout",
    SELLER_ACCEPT: "Seller Accepted",
    SELLER_COUNTER: "Seller Countered",
    SELLER_EXPIRED: "Seller Offer Lapsed",
    SELLER_HNB: "Seller Highest & Best",
    SELLER_REJECT: "Seller Rejected",
    SELLER_RESPONSE_PENDING: "Pending",
    SELLER_WITHDRAW: "Seller Withdrawn",
  };

  const getFormatPrice = (amount) => {
    if (amount?.length === 0 || isNaN(amount)) {
      return "";
    }
    return amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  };
  // Function to format address based on component type
  const getAddressAndDetails = (item) => {
    if (componentType === "offers") {
      const address = item?.propertyDetail?.propertyAddress;
      const offerActivity = item?.activeOffer?.offerActivity;

      return {
        propertyId: item?.propertyDetail?.propertyId || "N/A",
        fullAddress: address
          ? `${address.streetNumber} ${address.streetName}, ${address.city}, ${address.state} ${address.zip}`
          : "N/A",
        // Map the offer action to its corresponding display value
        offerAction: OFFER_ACTION_MAPPING[offerActivity] || "N/A",
        offerAmount: item?.activeOffer?.offerAmount
          ? new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(item.activeOffer.offerAmount)
          : "N/A",
      };
    } else {
      const address = item.propertyDetails?.address;
      return {
        fullAddress: address
          ? `${address.streetNumber} ${address.streetName}, ${address.city}, ${address.state} ${address.zip}`
          : "N/A",
      };
    }
  };

  // Function to get image based on component type
  const getImage = (item) => {
    if (componentType === "offers") {
      return item.defaultImagePath || sampleImage;
    } else {
      return (
        item.propertyDetails?.imageDetails[0]?.imageStoragePath || sampleImage
      );
    }
  };

  // Function to get status based on component type
  const getStatus = (item) => {
    if (componentType === "offers") {
      const statusStyle = getStatusStyle(item?.propertyDetail?.propertyStatus);
      return (
        <div className="status-container">
          <span
            className="status-badge"
            style={statusStyle}
            title={getStatusDescription(item?.propertyDetail?.propertyStatus)} // Add tooltip
          >
            {item?.propertyDetail?.propertyStatus || "N/A"}
          </span>
          {item.propertyTransactionStatus && (
            <small className="d-block text-muted mt-2">
              Transaction: {item.propertyTransactionStatus}
            </small>
          )}
        </div>
      );
    } else {
      return (
        <CountdownTimer
          listingDetails={item?.listingDetails}
          until={item?.listingDetails?.auctionTimeLeft}
          stylez={["mt-0", "p0"]}
        />
      );
    }
  };

  // Helper function to get status descriptions
  const getStatusDescription = (status) => {
    const statusDescriptions = {
      ACTV: "Property is actively available",
      PEND: "Offer is pending review",
      SOLD: "Property has been sold",
      WDRN: "Offer has been withdrawn",
      EXPR: "Offer has expired",
      CNCL: "Offer has been cancelled",
      DRAFT: "Offer is in draft state",
    };

    return statusDescriptions[status] || "Status unknown";
  };

  const getBidActions = () => {};

  const fetchCifData = (id) => {
    if (cifData !== null || cifData !== undefined) {
      return cifData[id];
    } else {
      return [];
    }
  };
  useEffect(() => {
    console.log("cif deatl changes -> ", cifDeatils);
    setCifData(cifDeatils);
  }, [cifDeatils]);

  const refreshBidsData = async () => {
    try {
      setIsLoading(true);

      await getBuyerFilterDetails();

      const bidOfferResponse = await getBidOfferDetails({
        listingType: "AUCN",
        propertyStatus: null,
        filterSelected: "N",
        buyerEmailId: null,
        propertyAddress: "",
        type: "",
        pageNo: 1,
      });

      setData(bidOfferResponse);

      if (bidOfferResponse && bidOfferResponse?.bidOfferDetailList) {
        const bidIds = bidOfferResponse.bidOfferDetailList.map(
          (item) => item.bidOfferSummary.bidOfferId
        );

        // Second API call with the collected bid IDs
        if (bidIds.length > 0) {
          const cifResponse = await getCifDetails(bidIds);
          console.log("cifResponse ->", cifResponse);
          setCifData(cifResponse);
          setIsLoading(false);
        }
      }
    } catch (error) {
      setError("Failed to fetch data: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Transform data based on component type
  const transformData = (inputData) => {
    if (componentType === "offers") {
      // Handle single offer data
      return [
        {
          image: getImage(inputData),
          addressDetails: getAddressAndDetails(inputData),
          status: getStatus(inputData),
          buttonText: "Place New Offer",
          propertyId: inputData.propertyId,
          listingId: inputData.listingId,
        },
      ];
    } else {
      // Handle bids data
      return (
        inputData?.map((item) => ({
          bidOfferId: item?.bidOfferSummary?.bidOfferId,
          imageUrl: item?.propertyDetails.imageDetails[0]?.imageStoragePath,
          image: getImage(item),
          addressDetails: getAddressAndDetails(item),
          status: getStatus(item),
          bidOfferActions: item?.bidOfferSummary?.bidOfferActions,
          buttonText: item?.bidOfferSummary?.bidOfferActions?.includes(
            "CONFIRM_NEGOTIATION"
          )
            ? `Confirm Offer for $${getFormatPrice(
                item?.listingDetails?.solicitationAmount
              )}`
            : item?.bidOfferSummary?.bidOfferActions?.includes("PLACE_BEST_BID")
            ? "Place Best Bid"
            : item?.bidOfferSummary?.bidOfferActions?.includes(
                "PLACE_BACKUP_BID"
              )
            ? "Place Backup Bid"
            : item?.bidOfferSummary?.bidOfferActions?.includes("PLACE_BID")
            ? "Place New Bid"
            : "",
          bidDetailsLink: `/bid-details/${item.listingDetails?.listingId}`,
          bidHistoryLink: `/bid-history/${item.listingDetails?.listingId}`,
          latestBidAmount: item?.bidOfferSummary?.latestOfferAmount,
          highestBidAmount: item?.listingDetails?.currentHighestPrice,
          bidStatus: item?.bidOfferSummary?.status,
          sellerResponse: item?.bidOfferSummary?.sellerResponse,
          bidStatusMessageData: item?.bidOfferSummary?.bidStatusMessageData,
          listingStatus: item?.listingDetails?.listingStatus,
          listingDetails: item?.listingDetails,
          cifDetails: fetchCifData(item?.bidOfferSummary?.bidOfferId),
          autoBidAmount: item?.bidOfferSummary?.autoBidAmount,
          propertyCategory:
            item?.propertyDetails?.commonAttributes.propCategory,
          propertyStatus: item?.propertyDetails?.commonAttributes?.status,
          propertyId: item?.propertyDetails?.propertyId,
          ownItNow: item?.bidOfferSummary?.bidOfferActions?.includes(
            "OWN_IT_NOW"
          )
            ? "Y"
            : "N",
        })) || []
      );
    }
  };
  // Check if data exists
  if (!bidOfferDetailList || bidOfferDetailList?.length === 0) {
    return (
      <div className="text-center">
        Currently you do not have active bids on any of the properties
      </div>
    );
  }

  // Transform data based on component type
  const transformedData = transformData(bidOfferDetailList);

  const handleBestBid = () => {
    setShowBestBidModal(true);
  };

  const navigateToOffers = async (data, offerType, item, type) => {
    resetPageNumber();

    trackButtonClick({
      eventName: "place_bid_action",
      eventCategory: "My Bids",
      eventSource: `${
        type === "OWNITNOW"
          ? "on own it now click"
          : offerType === "Place Backup Bid"
          ? "on place backup bid click"
          : offerType === "Place New Bid"
          ? "on place new bid click"
          : "on place bid click"
      }`,
      eventLabel: `${item.listingDetails.listingId || item.listingId}`,
      eventParams: {
        action_type:
          type === "OWNITNOW"
            ? "own_it_now"
            : offerType === "Place Backup Bid"
            ? "place_backup_bid"
            : offerType === "Place New Bid"
            ? "place_new_bid"
            : "place_bid",
      },
    });

    trackButtonClick({
      eventName: "user_type_check",
      eventCategory: "My Bids",
      eventSource: `${
        type === "OWNITNOW"
          ? "on own it now click"
          : offerType === "Place Backup Bid"
          ? "on place backup bid click"
          : offerType === "Place New Bid"
          ? "on place new bid click"
          : "on place bid click"
      }`,
      eventLabel: `${item.listingDetails.listingId || item.listingId}`,
    });

    try {
      const isAuthorised = await isUserAuthorised(
        item?.listingDetails?.listingId
      );

      trackApiCall({
        eventName: "user_type_check_success",
        eventParams: { user_type_check_result: true },
        eventCategory: "My Bids",
        eventSource: `${
          type === "OWNITNOW"
            ? "on own it now click"
            : offerType === "Place Backup Bid"
            ? "on place backup bid click"
            : offerType === "Place New Bid"
            ? "on place new bid click"
            : "on place bid click"
        }`,
        eventLabel: `${item.listingDetails.listingId || item.listingId}`,
      });

      if (isAuthorised.message === "USER_NOT_ALLOWED_TO_BID") {
        setAlertText(
          "You cannot place another bid as you are the current highest bidder."
        );
        setShowAlert(true);
      } else {
        const data = await getBidCenterDetails(item?.listingDetails?.listingId);
        console.log("data ", data);
        const details = await getPDPInitData(item?.listingDetails?.listingId);
        dispatch(fetchPDPBidCenterDataSuccess(data));
        dispatch(fetchPDPLatestBidCenterData(item?.listingDetails?.listingId));
        dispatch(fetchPDPInitialLoadSuccess(details));
        dispatch(setListingId(item?.listingDetails?.listingId));
        dispatch(setSelectedBidAmount(data.nextpossibleBidAmount));
        navigate("/bid");
      }

      // };
      //   const data = await getBidCenterDetails(item?.listingDetails?.listingId);
      //   console.log("data ", data);
      //   const details = await getPDPInitData(item?.listingDetails?.listingId);
      //   dispatch(fetchPDPBidCenterDataSuccess(data));
      //   dispatch(
      //     fetchPDPLatestBidCenterData(item?.listingDetails?.listingId)
      //   );
      //   dispatch(fetchPDPInitialLoadSuccess(details));
      //   dispatch(setListingId(item?.listingDetails?.listingId));
      //   dispatch(setSelectedBidAmount(data.nextpossibleBidAmount));

      //   navigate("/bid");
    } catch (error) {
      console.log(error);
    }
  };

  const navigateToPDP = (item, type = "") => {
    trackButtonClick({
      eventName: type === "image" ? "property_image_click" : "address_link_click",
      eventCategory: "My Bids",
      eventSource: "on property details click",
      eventLabel: item.listingId || item?.listingDetails?.listingId,
    });
    resetPageNumber();
    markInternalNavigation();
    navigate(getPropertyURL(`/property/${item?.propertyId}`, item?.propertyCategory, item?.propertyStatus));
  };

  const showBidDetails = async (id) => {
    const details = await getBidDetailsById(id);
    if (details) {
      setBidDetails(details);
      setShowDetails(true);
    }
  };

  const showEditAutoBid = async (payload) => {
    const details = await getAutoBidDetails(payload);
    if (details) {
      console.log("details -> ", details);
      setAutoBidData(details);
      setShowAutoBid(true);
    }
  };

  const handleWithdrawClose = () => {
    setShowWithdrawConfirmation(false);
  };

  const getBidStatusMessage = (item) => {
    console.log(item?.sellerResponse);

    console.log(
      "item?.bidStatusMessageData?.BACKUP_BID_EXPR_TIME_LEFT?",
      item?.bidStatusMessageData?.BACKUP_BID_EXPR_TIME_LEFT
    );
    switch (item?.bidStatus) {
      case "Highest":
        return "You are the highest bidder for this property";
      case "Outbid":
        return item.sellerResponse === "Pending"
          ? "Seller is reviewing all the bids received during the auction period"
          : item.sellerResponse === "Backup"
          ? "Your backup bid is Active for"
          : item.sellerResponse === "Rejected"
          ? "Go ahead and place a backup bid"
          : "You have been outbid";
      case "Best Bid Requested":
        return "Seller has requested for Highest and Best bid, which will expire in";
      case "Selected":
        return "You are the selected buyer for this property";
      case "Backup Bid":
        return "Your backup bid is Active for";
    }
  };

  const getBidHistoryDetails = async (id) => {
    const history = await getBidHistory(id);
    if (history) {
      setBidHistory(history?.data);
      setShowBidHistory(true);
    }
  };

  const handleClose = () => {
    setShowAlert(false);
  };

  const handleWithdrawBid = async () => {
    setIsLoading(true);
    setShowWithdrawConfirmation(false);
    // resetPageNumber()

    const payload = {
      backupBidWithDraw: "true",
      bidId: selectedBidId,
      listingId: selectedListingId,
    };

    const data = await withdrawBidById(payload);
    if (data.response === "SUCCESS") {
      resetPageNumber();
      setIsLoading(false);
    }
  };

  const onClick = (item, imageClick = false, e) => {
    if (imageClick) {
      e.stopPropagation();
      trackButtonClick({
        eventName: "property_image_click",
        eventCategory: "My Bids",
        eventSource: "on property details click",
        eventLabel: item.listingId || item?.listingDetails?.listingId,
      });
      resetPageNumber();
      navigateToPDP(item);
    } else {
      resetPageNumber();
      navigateToPDP(item);
    }
  };

  const shouldShowAuctionTimer = (item) => {
    const backupTimeLeft = parseInt(
      item?.bidStatusMessageData?.BACKUP_BID_EXPR_TIME_LEFT,
      10
    );
    const counterTimeLeft = parseInt(
      item?.bidStatusMessageData?.COUNTER_EXPR_TIME_LEFT,
      10
    );

    if (item.bidStatus === "Best Bid Requested") {
      const shouldShowTimer =
        (item?.bidStatus === "Backup Bid" ||
          item?.bidStatus === "Best Bid Requested" ||
          item?.sellerResponse === "Backup") &&
        counterTimeLeft > 0;

      return shouldShowTimer;
    } else {
      const shouldShowTimer =
        (item?.bidStatus === "Backup Bid" ||
          item?.bidStatus === "Best Bid Requested" ||
          item?.sellerResponse === "Backup") &&
        backupTimeLeft > 0;

      return shouldShowTimer;
    }
  };
  // function convertMsToHoursMinutes(ms) {
  //   const totalMinutes = Math.floor(ms / (1000 * 60));
  //   const hours = Math.floor(totalMinutes / 60);
  //   const minutes = totalMinutes % 60;
  //   return `${hours} hours and ${minutes} minutes`;
  // }

  // function formatDurationBetweenDates(endDate, clseDate) {
  //   if (!endDate || !clseDate) return "";
  //   const durationMs = (clseDate - endDate) / 10;
  //   if (durationMs <= 0) return "0 hours and 0 minutes";
  //   return convertMsToHoursMinutes(durationMs);
  // }

  // function convertMsToHoursMinutes(ms) {
  //   const totalMinutes = Math.floor(ms / (1000 * 60));
  //   const hours = Math.floor(totalMinutes / 60);
  //   const minutes = totalMinutes % 60;
  //   return `${hours} hours and ${minutes} minutes`;
  // }

  // function formatDurationBetweenDates(endDate, clseDate) {
  //   // console.log("gggg", endDate);
  //   // console.log("vddddd", clseDate);

  //   if (!endDate || !clseDate) return "";

  //   // Remove the division by 10 - this was causing the issue
  //   const durationMs = clseDate - endDate;

  //   if (durationMs <= 0) return "0 hours and 0 minutes";
  //   return convertMsToHoursMinutes(durationMs);
  // }
  // Complete calculateTimeLeft function
  function calculateTimeLeft(options) {
    try {
      options = options || {};
      var millseconds = options.millseconds || 0,
        sendIndividualUnits = options.sendIndividualUnits || null,
        sendAllUnits = options.sendAllUnits || null,
        seconds,
        minutes,
        hours,
        days;
      millseconds = millseconds / 1000;
      seconds = Math.floor(millseconds % 60);
      minutes = Math.floor((millseconds / 60) % 60);
      hours = Math.floor((millseconds / (60 * 60)) % 24);
      days = Math.floor(millseconds / (60 * 60 * 24));

      if (sendAllUnits) {
        var arr = [];
        if (days > 0) {
          arr.push(days > 1 ? days + " days" : days + " day");
        }
        if (hours > 0) {
          arr.push(hours > 1 ? hours + " hours" : hours + " hour");
        }
        if (minutes > 0) {
          if (days < 1) {
            arr.push(minutes > 1 ? minutes + " minutes" : minutes + " minute");
          }
        }
        if (seconds > 0) {
          if (days < 1 && hours < 1) {
            arr.push(seconds > 1 ? seconds + " seconds" : seconds + " second");
          }
        }
        if (arr.length === 0) {
          return null;
        } else {
          return arr[0] + " " + (arr[1] || "");
        }
      } else if (sendIndividualUnits) {
        return {
          days: {
            value: days,
            label: days != 1 ? "Days " : "Day",
          },
          hours: {
            value: hours,
            label: hours != 1 ? "Hours " : "Hour",
          },
          minutes: {
            value: minutes,
            label: minutes != 1 ? "Minutes " : "Minute",
          },
          seconds: {
            value: seconds,
            label: seconds != 1 ? "Seconds " : "Second",
          },
        };
      } else if (days > 0) {
        return days > 1 ? days + " days " : days + " day";
      } else if (hours > 0) {
        return hours > 1 ? hours + " hours " : hours + " hour";
      } else if (minutes > 0) {
        return minutes > 1 ? minutes + " minutes " : minutes + " minute";
      } else if (seconds > 0) {
        return seconds > 1 ? seconds + " seconds " : seconds + " second";
      } else {
        return null;
      }
    } catch (e) {
      console.error("Error in calculateTimeLeft:", e);
      return null;
    }
  }
  return (
    <div className="" style={{ backgroundColor: "white" }}>
      {isLoading ? (
        <div className="text-center p-4 mt30">
          <div className="mt30 pt30" role="">
            <Loader />
          </div>
        </div>
      ) : (
        transformedData.map((item, index) => (
          <Row
            key={index}
            className="align-items-center mb-4"
            style={{
              paddingTop: 20,
              paddingBottom: 20,
              borderBottom: "1px solid #ebebeb",
            }}
          >
            <Col xs={0} md={2}>
              <Card className="border-0">
                <a
                  href={getPropertyURL(`/property/${item?.propertyId}`, item?.propertyCategory, item?.propertyStatus)}
                  className="position-relative w-100"
                  style={{ paddingBottom: "60%" }}
                  onClick={(e) => {
                    e.preventDefault();
                    navigateToPDP(item, "image");
                  }}
                >
                  <img
                    src={item?.imageUrl || "/assets/images/no-photo.jpg"}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/assets/images/no-photo.jpg";
                    }}
                    className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover rounded"
                    style={{ cursor: "pointer" }}
                    alt="Property"
                  />
                </a>
              </Card>
            </Col>
            <Col xs={12} md={4} className="d-flex align-items-start">
              <div className="w-100 mt-3 mt-md-0">
                {componentType === "offers" ? (
                  <>
                    <a
                      href={getPropertyURL(`/property/${item?.propertyId}`, item?.propertyCategory, item?.propertyStatus)}
                      onClick={(e) => {
                        e.preventDefault();
                        navigateToPDP(item, "address");
                      }}
                      className="text-decoration-none"
                    >
                      <p
                        className="fw-bold mb-2 pointer"
                        style={{ fontSize: "12px" }}
                        // onClick={() => navigateToPDP(item, "address")}
                      >
                        {item.addressDetails.propertyId}{" "}
                        {item.addressDetails.fullAddress}
                      </p>
                    </a>
                    <p
                      className="mb-2"
                      style={{ fontSize: "12px", color: "#666" }}
                    >
                      <span className="fw-semibold">Offer Action:</span>{" "}
                      {item.addressDetails.offerAction}
                    </p>
                    <p
                      className="mb-0 me-2"
                      style={{ fontSize: "12px", color: "#666" }}
                    >
                      <span className="fw-semibold">Offer Amount:</span>{" "}
                      {item.addressDetails.offerAmount}
                    </p>
                  </>
                ) : (
                  <>
                    <a
                      href={getPropertyURL(`/property/${item?.propertyId}`, item?.propertyCategory, item?.propertyStatus)}
                      onClick={(e) => {
                        e.preventDefault();
                        navigateToPDP(item, "address");
                      }}
                      className="text-decoration-none"
                    >
                      <p
                        className="propAddress p0 m0 pointer"
                        onClick={() => navigateToPDP(item, "address")}
                      >
                        {item?.addressDetails?.fullAddress}
                      </p>
                    </a>
                    <p className="auctionPrice">
                      My Latest Bid: ${getFormatPrice(item?.latestBidAmount)}
                    </p>
                    {item?.bidStatus !== "Backup Bid" &&
                      item?.listingStatus === "Active" && (
                        <p className="auctionPrice">
                          Highest Bid:${getFormatPrice(item?.highestBidAmount)}
                        </p>
                      )}
                    <p className="fst-italic subTitleItalic pt10">
                      {getBidStatusMessage(item)}
                    </p>
                    <div className="fst-italic subTitleItalic pt10">
                      {shouldShowAuctionTimer(item) && (
                        <AuctionTimeLeft
                          listingDetails={item?.listingDetails}
                          until={
                            item?.bidStatus === "Backup Bid" ||
                            item?.sellerResponse === "Backup"
                              ? item?.bidStatusMessageData
                                  ?.BACKUP_BID_EXPR_TIME_LEFT
                              : item?.bidStatusMessageData
                                  ?.COUNTER_EXPR_TIME_LEFT
                          }
                        />
                      )}
                    </div>
                  </>
                )}
              </div>
            </Col>
            <Col xs={12} md={3} className="">
              <div>
                <p className="mb-0" style={{ fontSize: "12px" }}>
                  {item.status}
                </p>
              </div>
            </Col>
            <Col
              xs={12}
              md={3}
              className="d-flex flex-column align-items-center align-items-sm-end"
            >
              {item?.bidOfferActions !== null &&
                item?.bidOfferActions?.length &&
                item?.buttonText?.length > 0 && (
                  <Button
                    variant="btn booking_btn myBids-btn-thm float-end"
                    style={{ width: "65%" }} // Adjusted width to ensure responsiveness
                    onClick={() => {
                      setSelectedBidId(item?.bidOfferId);
                      setSelectedListingId(item?.listingDetails?.listingId);

                      if (
                        item?.bidOfferActions?.includes("CONFIRM_NEGOTIATION")
                      ) {
                        setOpenConfirmOffer(true);
                        trackButtonClick({
                          eventName: `confirm_negotiation_click`,
                          eventCategory: "My Bids",
                          eventSource: "on confirm negotiation click",
                          eventLabel: `${
                            item.listingDetails.listingId || item.listingId
                          }`,
                        });
                      } else if (
                        item?.bidOfferActions?.includes("PLACE_BEST_BID")
                      ) {
                        setSeletecPropCat(item?.propertyCategory);
                        setShowBestBidModal(true);
                        trackButtonClick({
                          eventName: `place_best_bid_click`,
                          eventCategory: "My Bids",
                          eventSource: "on place best bid click",
                          eventLabel: `${
                            item.listingDetails.listingId || item.listingId
                          }`,
                        });
                      } else {
                        navigateToOffers(data, item.buttonText, item);
                      }
                    }}
                  >
                    {item?.bidOfferActions?.includes("PLACE_BEST_BID")
                      ? "Place Best Bid"
                      : item.buttonText}
                  </Button>
                )}
              {item?.listingDetails?.ownItNowFlag === true &&
                item?.bidOfferActions?.includes("OWN_IT_NOW") && (
                  <Button
                    className="mt10"
                    variant="btn booking_btn myBids-btn-thm end-the-auction-btn float-end"
                    style={{ width: "85%" }} // Adjusted width to ensure responsiveness
                    onClick={() => {
                      dispatch(enableOwnItNow(true));
                      navigateToOffers(data, item.buttonText, item, "OWNITNOW");
                    }}
                  >
                    End the Auction now for $
                    {getFormatPrice(item?.listingDetails?.ownItNowPrice)}
                  </Button>
                )}

              <div className="mt-2 mob-center" style={{ textAlign: "right" }}>
                {item?.bidOfferActions?.includes("WITH_DRAW_BID") ? (
                  <>
                    <a
                      href="#"
                      className=" text-decoration-underline viewMoreLink mb-2"
                      onClick={(e) => {
                        e.preventDefault();
                        trackButtonClick({
                          eventName: "withdraw_bid",
                          eventCategory: "My Bids",
                          eventSource: "on withdraw bid click",
                          eventLabel: `${
                            item.listingDetails.listingId || item.listingId
                          }`,
                        });
                        setShowWithdrawConfirmation(true);
                        setSelectedBidId(item?.bidOfferId);
                        setSelectedListingId(item?.listingDetails?.listingId);
                      }}
                    >
                      Withdraw
                    </a>
                    <br />
                  </>
                ) : (
                  <></>
                )}

                {item?.bidOfferActions?.includes("EDIT_AUTO_BID") ? (
                  <>
                    <a
                      href="#"
                      className=" text-decoration-underline viewMoreLink mb-2"
                      onClick={(e) => {
                        e.preventDefault();
                        trackButtonClick({
                          eventName: "edit_auto_bid",
                          eventCategory: "My Bids",
                          eventSource: "on edit auto bid click",
                          eventLabel: `${
                            item.listingDetails.listingId || item.listingId
                          }`,
                        });

                        setSeletecPropCat(item?.propertyCategory);
                        setSelectedBidId(item?.bidOfferId);
                        setSelectedListingId(item?.listingDetails?.listingId);
                        setSelectedBidAmountCIF(item?.latestBidAmount);

                        const payload = {
                          autoBidAmount: item?.autoBidAmount,
                          bidId: item?.bidOfferId,
                          listingId: item?.listingDetails?.listingId,
                        };
                        showEditAutoBid(payload);
                      }}
                    >
                      Edit Auto Bid
                    </a>
                    <br />
                  </>
                ) : (
                  <></>
                )}

                <a
                  href="#"
                  className=" text-decoration-underline viewMoreLink mb-2"
                  onClick={async (e) => {
                    e.preventDefault();
                    setActionLoadingState(
                      `bidDetails-${item?.bidOfferId}`,
                      true
                    );

                    trackButtonClick({
                      eventName:
                        componentType === "offers"
                          ? "view_offer_details_click"
                          : "view_bid_details_click",
                      eventCategory: "My Bids",
                      eventSource: `${
                        componentType === "offers"
                          ? "on offer details click"
                          : "on bid details click"
                      }`,
                      eventLabel: `${
                        item.listingDetails.listingId || item.listingId
                      }`,
                    });
                    setSeletecPropCat(item?.propertyCategory);
                    try {
                      await showBidDetails(item?.bidOfferId);
                    } finally {
                      setActionLoadingState(
                        `bidDetails-${item?.bidOfferId}`,
                        false
                      );
                    }
                  }}
                >
                  {isActionLoading(`bidDetails-${item?.bidOfferId}`) ? (
                    <span>
                      <span
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                      ></span>
                      Loading...
                    </span>
                  ) : (
                    componentType !== "offers" && "Bid Details"
                  )}
                </a>
                <br />
                <>
                  {item?.listingStatus === "Active" && (
                    <>
                      <a
                        href="#"
                        className="text-decoration-underline viewMoreLink mb-2"
                        onClick={async (e) => {
                          e.preventDefault();
                          setActionLoadingState(
                            `bidHistory-${item?.listingDetails?.listingId}`,
                            true
                          );

                          trackButtonClick({
                            eventName: "view_bid_history_click",
                            eventCategory: "My Bids",
                            eventSource: "on bid history click",
                            eventLabel: `${
                              item.listingDetails.listingId || item.listingId
                            }`,
                          });
                          setSeletecPropCat(item?.propertyCategory);
                          setSelectedPropAdrs(
                            item?.addressDetails?.fullAddress
                          );
                          try {
                            await getBidHistoryDetails(
                              item?.listingDetails?.listingId
                            );
                          } finally {
                            setActionLoadingState(
                              `bidHistory-${item?.listingDetails?.listingId}`,
                              false
                            );
                          }
                        }}
                      >
                        {isActionLoading(
                          `bidHistory-${item?.listingDetails?.listingId}`
                        ) ? (
                          <span>
                            <span
                              className="spinner-border spinner-border-sm me-1"
                              role="status"
                            ></span>
                            Loading...
                          </span>
                        ) : (
                          "Bid History"
                        )}
                      </a>
                      <br />
                    </>
                  )}

                  {/* {(item?.cifDetails?.allowedOperation?.includes(
                    "CIF_UPDATE"
                  ) ||
                    item?.cifDetails?.allowedOperation?.includes(
                      "CIF_ADD"
                    )) && (
                    <a
                      href={`/portal/ci/document/${item?.cifDetails?.cifId}`}
                      target="_blank"
                      className="text-decoration-underline viewMoreLink mb-2"
                      onClick={() => {
                        trackButtonClick({
                          eventName: "cif_link_click",
                          eventCategory: "My Bids",
                          eventSource: "on edit contact information form click",
                          eventLabel: `${
                            item.listingDetails.listingId || item.listingId
                          } | Edit contact information form`,
                        });
                      }}
                    >
                      <MdErrorOutline size={24} color="red" />
                      Edit contact information Form
                    </a>
                  )} */}
                  {item?.cifDetails?.allowedOperation?.includes(
                    "CIF_UPDATE"
                  ) && (
                    <a
                      href={`/ci/document/${item?.cifDetails?.cifId}`}
                      target="_blank"
                      className="text-decoration-underline viewMoreLink mb-2"
                      onClick={() => {
                        trackButtonClick({
                          eventName: "cif_link_click",
                          eventCategory: "My Bids",
                          eventSource: "on edit contact information form click",
                          eventLabel: `${
                            item.listingDetails.listingId || item.listingId
                          } | Edit contact information form`,
                        });
                      }}
                    >
                      <MdErrorOutline size={24} color="red" />
                      Edit contact information Form
                    </a>
                  )}
                  {item?.cifDetails?.allowedOperation?.includes("CIF_ADD") && (
                    <>
                      <a
                        href={`/ci/document/${item?.cifDetails?.cifId}`}
                        target="_blank"
                        className="viewMoreLink mb-2">
                        <MdErrorOutline size={24} color="red" />
                        <span className=" text-decoration-underline">
                          {" "}
                          Complete contact information form within{" "}
                        </span>
                        <span className="timer-contact-info">
                          {calculateTimeLeft({
                            millseconds: item?.cifDetails?.timeLeft || 36691438,
                            sendAllUnits: true,
                          }) || "0 minutes"}
                        </span>
                      </a>
                    </>
                  )}
                </>
              </div>
            </Col>
          </Row>
        ))
      )}

      <BidDetailsModal
        show={showDetails}
        handleClose={() => setShowDetails(false)}
        title={componentType === "offers" ? "Offer Details" : "Bid Details"}
        bidDetailsById={bidDetails}
        propertyCategory={selectedPropCat}
      />
      <BidHistoryModal
        show={showBidHistory}
        handleClose={() => setShowBidHistory(false)}
        addresDetails={selectedPropAdrs}
        bidHistory={bidHistory}
        propertyCategory={selectedPropCat}
      />
      {autoBidData && (
        <AutoBidModal
          show={showAutoBid}
          handleClose={() => setShowAutoBid(false)}
          autoBidData={autoBidData}
          bidAmount={selectedBidAmountCIF}
          autoBidAmountFormatted={
            autoBidData?.bidAmountDetail?.bidAmountFormatted
          }
          bidId={selectedBidId}
          listingId={selectedListingId}
          propertyCategory={selectedPropCat}
        />
      )}

      <ConfirmOffer
        handleClose={() => setOpenConfirmOffer(false)}
        show={openConfirmOffer}
        listingId={selectedListingId}
        propertyCategory={selectedPropCat}
        onSuccess={resetPageNumber}
      />

      <PlaceBestBidModal
        show={showBestBidModal}
        onHide={() => setShowBestBidModal(false)}
        listingId={selectedListingId}
        bidId={selectedBidId}
        propertyCategory={selectedPropCat}
        // onSubmit={handleBestBidSubmit}
      />
      <Modal show={showAlert} onHide={handleClose}>
        <Modal.Header closeButton className="license-title">
          <Modal.Title className="text-white roboreg">Place Bid</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="p-4 text-center roboreg">{alertText}</p>
          <div className="d-flex justify-content-center">
            <button className="no-btn" onClick={() => handleClose()}>
              Ok
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <div className="confirmationModel">
        <Modal show={showWithdrawConfirmation} onHide={handleWithdrawClose}>
          <Modal.Header closeButton className="license-title">
            Confirm Withdraw
          </Modal.Header>
          <Modal.Body>
            <p className="text-center pt20">
              Are you sure you want to withdraw your bid?
            </p>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <button
              onClick={handleWithdrawBid}
              className="btn hubzu-btn-thm rounded"
            >
              Yes
            </button>
            <button
              onClick={handleWithdrawClose}
              className="confirm-withdraw-no"
            >
              No
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

// Helper function to get status styles
const getStatusStyle = (status) => {
  const baseStyle = {
    padding: "8px 16px",
    borderRadius: "20px",
    fontSize: "14px",
    fontWeight: "500",
    display: "inline-block",
    textTransform: "capitalize",
  };

  const statusStyles = {
    ACTV: {
      ...baseStyle,
      backgroundColor: "#e8f5e9",
      color: "#2e7d32",
      border: "1px solid #a5d6a7",
    },
    PEND: {
      ...baseStyle,
      backgroundColor: "#fff3e0",
      color: "#ef6c00",
      border: "1px solid #ffcc80",
    },
    SOLD: {
      ...baseStyle,
      backgroundColor: "#e3f2fd",
      color: "#1565c0",
      border: "1px solid #90caf9",
    },
    WDRN: {
      ...baseStyle,
      backgroundColor: "#fafafa",
      color: "#616161",
      border: "1px solid #e0e0e0",
    },
    EXPR: {
      ...baseStyle,
      backgroundColor: "#ffebee",
      color: "#c62828",
      border: "1px solid #ef9a9a",
    },
    CNCL: {
      ...baseStyle,
      backgroundColor: "#fce4ec",
      color: "#c2185b",
      border: "1px solid #f48fb1",
    },
    DRAFT: {
      ...baseStyle,
      backgroundColor: "#f3e5f5",
      color: "#7b1fa2",
      border: "1px solid #ce93d8",
    },
    default: {
      ...baseStyle,
      backgroundColor: "#f5f5f5",
      color: "#616161",
      border: "1px solid #e0e0e0",
    },
  };

  return statusStyles[status] || statusStyles.default;
};

export default PropertyDetailsCard;
